import { pl } from "../../../../date-fns/locale/pl.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    pl
  }
};